<template>
	<section>
		<div class="container">
			<div class="announcement">
				<swiper :effect="'cards'" :grabCursor="true" :modules="modules" class="mySwiper">
					<swiper-slide class="item" v-for="fs in fasites" :key="fs.id" :style="{backgroundImage: 'url('+fs.img+')'}">
						<div class="data">
							<span>{{fs.nome}}</span>
							<span>{{fs.descricao}}</span>
							<div class="play" @click="this.audio(fs.id)"><i class="fa-solid fa-play"></i></div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
			<div class="attLoc">
				<div class="top">
					<div class="title" @click="$store.dispatch('getNot', {title: 'aa', text: 'aa'})">Atualizações</div>
					<div class="subTitle">Locutores recentes</div>
				</div>
				<div class="content">
					<div class="box" v-for="(loc, i) in locutores" :key="i">
						<div class="boxAvatar" :style="{background: '#'+loc.cor}">
							<div class="avatar" :style="{backgroundImage: 'url('+loc.avatar+')'}"></div>
						</div>
						<div class="iconFS" :style="{backgroundImage: 'url('+loc.icon+')'}"></div>
						<div class="nick"><span>{{loc.name}}</span> entrou ao vivo</div>
						<div class="time"><i class="fas fa-clock"></i>&nbsp; {{loc.time}}</div>
					</div>
				</div>
			</div>
		</div>
		<Rank :loc="locutores" />
	</section>
</template>

<script>
import {base} from '../../var.js'
import { Swiper, SwiperSlide } from 'swiper/vue';
import "swiper/swiper.min.css";
import { EffectCards } from "swiper";
import Rank from '../components/rank.vue'
import Player from '../components/player.vue'
import axios from 'axios';

export default {
	name: 'HomePage',
	mixins: [Player],
	components: {
		Swiper,
		SwiperSlide,
		Rank
	},
	setup() {
		return {
			modules: [EffectCards],
		};
	},
	data(){
		return {
			iconFS: 'https://habborank.site/assets/img/flag_br.png',
			fasites: [],
			locutores: [],
			last_loc: ''
		}
	},
	mounted: function() {
		document.title = 'HabboRank • Audiência dos fã-sites!'
		setInterval(() => {
			this.getLoc();this.getFasites();
		}, 20000);
		this.getLoc();this.getFasites();
	},
	methods: {
		async getFasites() {
			const req = await axios.get(base+"fasites");
			this.fasites = req.data.fasites;
		},
		async getLoc() {
			const req = await axios.get(base+"locutoresAtt");
			this.locutores = req.data.locutores;
			if(this.locutores.length != 0) {
				let data = {
					title: 'Novo locutor ao vivo!',
					text: req.data.locutores[0].name+' entrou ao vivo em '+req.data.locutores[0].fasite+'.'
				}
				if(req.data.locutores[0].name != this.last_loc && this.last_loc != ''){
					this.$store.dispatch('getNot', data)
				}
				this.last_loc = req.data.locutores[0].name
			}
		}
	}
}
</script>

<style scoped>
.announcement {
	float: left;
	width: 60%;
	height: 380px;
}
.swiper {
  width: 70%;
  height: 100%;
  overflow: initial;
}

.swiper-wrapper {
	width: 80%;
}

.swiper-slide {
  border-radius: 20px;
  color: #fff;
}

.swiper-slide .data {
	float: left;
	margin-top: 320px;
	width: 100%;
	height: 40px;
	font-size: 16px;
	font-weight: 600;
	padding: 0 25px;
}

.swiper-slide .data span {
	float: left;
	width: 100%;
	height: 20px;
	margin-top: 4px;
}
.swiper-slide .data span:last-of-type {font-size: 14px; font-weight: 400;}

.swiper-slide .data div.play {
	float: right;
	width: 30px;
	height: 30px;
	color: #fff;
	font-size: 14px;
	text-align: center;
	line-height: 30px;
	margin-top: -30px;
	transition: all .3s ease;
}
.swiper-slide .data div.play:hover {background-color: rgba(255,255,255,.3);border-radius: 4px;}

.announcement .swiper-slide.item {
	background-position: center;
	background-size: cover;
	overflow: hidden;
}

.attLoc {
	position: relative;
	width: 20%;
	height: auto;
	margin-top: 10px;
}

.attLoc .content .box {
	float: left;
	width: 100%;
	height: 50px;
	margin-top: 13px;
}

.attLoc .content .box .boxAvatar {
	width: 46px;
	height: 46px;
	float: left;
	border-radius: 4px;
	margin-top: 0px;
}

.attLoc .content .box .avatar {
	float: left;
	width: 50px;
	height: 48px;
	background-position: center;
	background-repeat: no-repeat;
	margin-top: -2px;
}

.attLoc .content .box .nick {
	float: left;
	width: 79%;
	height: 20px;
	font-size: 14px;
	margin: 4px 0 0 10px;
	line-height: 20px;
	white-space: nowrap;
}
.attLoc .content .box .nick span {font-weight: 600;}

.attLoc .content .box .iconFS {
	float: left;
	width: 20px;
	height: 20px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 85%;
	margin: 34px 0 0 -12px;
	filter: drop-shadow(0,0,0, #fff);
}

.attLoc .content .box .time {
	position: absolute;
	width: auto;
	height: 20px;
	line-height: 20px;
	font-size: 13px;
	margin: 26px 0 0 60px;
	color: #aaa;
}

</style>